$(document).ready ->
  game = new Game config

random = (min = 0, max = 1) ->
  Math.round(Math.random() * (max - min) + min)

randomFloat = (min = -1, max = 1) ->
  Math.random() * (max - min) + min

formatTime = (time) ->
  (time/1000).toFixed 2

pythagoras = (a, b) ->
  Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2))

isFunction = (functionToCheck) ->
 getType = {}
 functionToCheck && getType.toString.call(functionToCheck) is '[object Function]';

simplePluralize = (number, cases) ->
    _case = 0
    short = number%100
    last = short%10

    if !last or last > 4 or 4 < short < 21
      _case = 2
    else if last > 1
      _case = 1

    number + ' ' + cases[_case]

getString = (string) ->
  # Handle if string is already a plain string (not an object)
  if typeof string is 'string'
    return string
  
  # Try to find matching language
  if string[navigator.language]
    return string[navigator.language]
  
  # Try to find language without region (e.g., 'en' from 'en-US')
  lang = navigator.language.split('-')[0]
  if string[lang]
    return string[lang]
  
  # Fallback: return 'en' if available, otherwise first property found
  if string['en']
    return string['en']
  
  # Last resort: return first available value
  for key, value of string
    if typeof value is 'string'
      return value
  
  # If nothing works, return the original string representation
  return JSON.stringify(string) or ''
  